import { toast } from 'sonner';
import { formatCurrency } from '@/lib/utils/formatters';

export function showAllocationSuccessToast(
  totalAllocated: number,
  transactionCount: number,
  promiseFulfilled?: boolean,
  caseUpdated?: boolean
) {
  const details: string[] = [
    `${formatCurrency(totalAllocated)} allocated to ${transactionCount} transaction${transactionCount > 1 ? 's' : ''}`,
  ];

  if (promiseFulfilled) {
    details.push('Promise to Pay marked as "Paid"');
  }

  if (caseUpdated) {
    details.push('Collection case updated');
  }

  toast.success('Allocation Completed', {
    description: (
      <div className="space-y-1">
        {details.map((detail, index) => (
          <div key={index}>• {detail}</div>
        ))}
      </div>
    ),
    duration: 5000,
  });
}
